const random_number_QTY = new Random_Number( { max_attempts: 50, max: 30, min: 2 } );
const random_number_PURCHASES = new Random_Number( { max_attempts: 50, max: 30, min: 9 } );

const ecommerce_qty = ( ( random ) =>
{

  const qty_elements = Array.from( cached_elements.get_nodelist( '[data-eqty]' ) );
  const countup_instances = [ ...create_countup_instances( qty_elements, random ) ];

  return ( num ) =>
  {
    countup_instances.forEach( ( instance, i ) =>
    {
      const node = cached_elements.get_node( `#${instance.target}` );
      const current_qty = Number( node.getAttribute( 'data-eqty' ) );
      const qty = Number( ( current_qty - num[ i ] ) );
      let new_qty = check_stock( node, qty, current_qty, num[ i ], instance );

      instance.update( new_qty );

      node.setAttribute( 'data-eqty', new_qty );
    } );
  }
} );


const check_stock = ( node, qty, current_qty, new_number, instance ) =>
{
  if ( qty <= 0 )
  {
    node.classList.add( 'pop' );
    qty = 100;
    substract_leftover_stock( node, instance, current_qty, new_number, 2000 );
  }
  else if ( node.classList.contains( 'pop' ) )
  {
    node.classList.remove( 'pop' );
  }
  return qty;
}

const substract_leftover_stock = ( node, instance, current_qty, new_number, delay ) =>
{
  setTimeout( () =>
  {
    instance.update( 100 - ( new_number - current_qty ) );
    node.setAttribute( 'data-eqty', 100 - ( new_number - current_qty ) );
  }, delay );
}

const ecommerce_qty_counters = ecommerce_qty( random_number_QTY );

const p_counter = ecommerce_counter( '.purchase-info__brought-x', 58000, random_number_PURCHASES, ( num ) =>
{
  ecommerce_qty_counters( num );
} );

p_counter( p_counter, true );